import { lazy, Suspense } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { closeAuthModal, openAuthModal } from '@/store/slices/uiSlice';

// Split out of the main bundle: most visits never open either sheet, and the
// pair pulls in the whole registration flow behind them.
const LoginModal = lazy(() => import('./LoginModal'));
const RegisterModal = lazy(() => import('./RegisterModal'));

/**
 * Mount point for the two auth sheets.
 *
 * One instance, rendered by the layout, driven by `ui.authModal` — so the header
 * buttons, the drawer, the bottom bar and the /login and /register URLs all open
 * the same sheet instead of each keeping their own copy of the state.
 */
export default function AuthModals() {
  const which = useAppSelector((state) => state.ui.authModal);
  const dispatch = useAppDispatch();

  if (!which) return null;

  const close = () => dispatch(closeAuthModal());

  return (
    <Suspense fallback={null}>
      {which === 'login' ? (
        <LoginModal onClose={close} onSwitchToRegister={() => dispatch(openAuthModal('register'))} />
      ) : (
        <RegisterModal onClose={close} onSwitchToLogin={() => dispatch(openAuthModal('login'))} />
      )}
    </Suspense>
  );
}
